'use strict';

var addCommas = require('add-commas');

var addCounts = function addCounts(item, counts) {
  if (counts !== null && counts !== undefined) {
    item.count = counts[item.value] || 0;
    item.displayCount = addCommas(item.count);
  }

  return item;
};

module.exports = addCounts;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/add-counts.js
 ** module id = 492
 ** module chunks = 0
 **/